import Vue from 'vue'
import store from '@/store'
import router from '@/router'
import crossclassification from './crossclassification.vue'
import i18n from '@/utils/i18n';
let instance = null

function getInstance() {
  if (!instance) {
    const Ctor = Vue.extend(crossclassification)
    instance = new Ctor({
      store,
      router,
      i18n,
      el: document.createElement('div')
    })
    document.body.appendChild(instance.$el)
  }
  return instance
}

export default {
  install(Vue) {
    Vue.prototype.$modal = {
      open(options) {
        getInstance().open(options)
      },
      close() {
        instance && instance.close()
      }
    }
  }
}
